import { display } from 'html2canvas/dist/types/css/property-descriptors/display';
import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { MedsusPublicHeader } from './MedsusPublicHeader';
import { IMedsusCard } from './cardMedsusItem';
import { CardMedsus } from './cardMedus';
import { mockData } from './mockData';
import {
  DetailPageWrapper,
  DetailHeader,
  BackButton,
  DetailTitle,
  DetailContent,
  LoadingSpinner,
  LoadingContainer,
  ErrorMessage,
  ErrorText,
  RetryButton,
  EmptyVmpMessage,
} from './styles';
import BoxConteudo from '../../../components/BoxConteudo';
import CustomCol from '../../../components/CustomCol';
import CustomInputDate from '../../../components/CustomInputs/CustomInputDate';
import CustomInputLink from '../../../components/CustomInputs/CustomInputLink';
import CustomInputText from '../../../components/CustomInputs/CustomInputText';
import CustomOffcanvas from '../../../components/CustomOffcanvas';
import CustomRow from '../../../components/CustomRow';
// import CustomSelect from '../../../components/CustomSelects/CustomSelect'; // Comentado - requer autenticação
import WorkspaceFicha from '../../../components/WorkspaceFicha';
// import { useSelect } from '../../../modules/contexts/Select/useSelect';
import {
  IMedsusDiretrizRegistro,
  IMedsusDiretrizVmpItem,
} from '../../../modules/types/MedsusNew';
import { getDiretrizesByMedicamentoPublic } from '../../../services/medsus/medsusItemService';
import theme from '../../../theme';
// import { CidMedsus } from '../../daf/ProdutosDAF/MedSUS/components/CidMedsus'; // Comentado - requer autenticação
// import { CriterioMedsus } from '../../daf/ProdutosDAF/MedSUS/components/CriterioMedsus'; // Comentado - requer autenticação
// import { DocumentoMedsus } from '../../daf/ProdutosDAF/MedSUS/components/DocumentoMedsus'; // Comentado - requer autenticação

interface DetailParams extends Record<string, string | undefined> {
  id: string;
}

const ScrollContainer = styled.div`
  width: 95vw;
  max-height: 85vh;
  padding: 20px;
  overflow-y: auto;
  overflow-x: hidden;

  /* Chrome, Edge, Safari */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Firefox */
  scrollbar-width: none;

  /* IE */
  -ms-overflow-style: none;
`;

export function MedsusPublicDetail() {
  const { id } = useParams<DetailParams>();
  const navigate = useNavigate();
  const [isHover, setIsHover] = useState(false);

  const [show, setShow] = useState(false);
  const [selectedCard, setSelectedCard] = useState<IMedsusCard | null>(null);

  const handleOpen = (id: string) => {
    const card = mockData.find((item) => item.id === id);
    if (!card) return;

    setSelectedCard(card);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedCard(null);
  };
  // const { getSelectDominioPai } = useSelect();

  // Enums - Comentado temporariamente pois getSelectDominioPai() requer autenticação
  // const componentesAfOptions = getSelectDominioPai(1);
  // const grupoFinanciamentoOptions = getSelectDominioPai(32);
  // const tipoDiretrizOptions = getSelectDominioPai(105);
  // const statusDiretrizOptions = getSelectDominioPai(111);
  // const responsavelDiretrizOptions = getSelectDominioPai(114);
  // const abrangenciaOptions = getSelectDominioPai(122);
  // const responsavelRegistroOptions = getSelectDominioPai(129);

  const [directory, setDirectory] = useState<IMedsusDiretrizRegistro | null>(
    null,
  );
  const [vmps, setVmps] = useState<IMedsusDiretrizVmpItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    if (!id) {
      setError('ID da diretriz não foi fornecido');
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const directoryData = await getDiretrizesByMedicamentoPublic(id);
      setDirectory(directoryData);
      setVmps(directoryData.diretrizesVmp || []);
      // console.log('Diretriz clínica:', directoryData);
    } catch (err) {
      setError('Erro ao carregar dados. Tente novamente.');
      console.error('Erro ao obter dados:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const handleRetry = () => {
    fetchData();
  };

  if (loading) {
    return (
      <DetailPageWrapper>
        <DetailHeader>
          <BackButton onClick={() => navigate('/medsus')} title="Voltar">
            <FaArrowLeft />
          </BackButton>
          <DetailTitle>Carregando...</DetailTitle>
        </DetailHeader>
        <DetailContent>
          <LoadingContainer>
            <LoadingSpinner />
            <p>Carregando dados...</p>
          </LoadingContainer>
        </DetailContent>
      </DetailPageWrapper>
    );
  }

  if (error || !directory) {
    return (
      <DetailPageWrapper>
        <DetailHeader>
          <BackButton onClick={() => navigate('/medsus')} title="Voltar">
            <FaArrowLeft />
          </BackButton>
          <DetailTitle>Erro ao carregar</DetailTitle>
        </DetailHeader>
        <DetailContent>
          <ErrorMessage>
            <ErrorText>{error || 'Dados não encontrados'}</ErrorText>
            <RetryButton onClick={handleRetry}>Tentar novamente</RetryButton>
          </ErrorMessage>
        </DetailContent>
      </DetailPageWrapper>
    );
  }

  return (
    <DetailPageWrapper>
      <MedsusPublicHeader />

      <DetailHeader>
        <BackButton onClick={() => navigate('/medsus')} title="Voltar">
          <FaArrowLeft />
        </BackButton>
        <DetailTitle>{directory.nome}</DetailTitle>
      </DetailHeader>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
        }}
      >
        {/* <div
          style={{
            width: '95vw',
            maxHeight: '80vh',
            padding: '20px',
            overflowY: 'auto',
            overflowX: 'hidden',
          }}
        > */}
        <ScrollContainer>
          <CardMedsus items={mockData} onCardClick={handleOpen} />
        </ScrollContainer>
        <CustomOffcanvas
          show={show}
          onClose={handleClose}
          title={selectedCard?.titulo ?? ''}
          width="70vw"
          placement="end"
          autoFocusTitle
          data-testid="medsus-detail-panel"
        >
          {selectedCard && (
            <WorkspaceFicha>
              <BoxConteudo boxTitulo="Apresentação">
                <div
                  style={{
                    fontSize: '1.3rem',
                    marginTop: '-10px',
                    textAlign: 'justify',
                  }}
                >
                  Este protocolo estabelece diretrizes clínicas para
                  diagnóstico, tratamento e acompanhamento dos pacientes com a
                  condição em questão, visando garantir padronização
                  assistencial, uso racional de medicamentos e melhor desfecho
                  terapêutico no âmbito do SUS.
                </div>

                <div
                  style={{
                    marginTop: '16px',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    width: '100%',
                  }}
                >
                  <div
                    style={{
                      padding: '8px 12px',
                      backgroundColor: '#F0F4FF',
                      borderRadius: '6px',
                    }}
                  >
                    <a
                      href="https://www.gov.br/saude/pt-br/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: '#1351B4',
                        fontWeight: 600,
                        fontSize: '1.1rem',
                        textDecoration: 'none',
                      }}
                    >
                      Acessar documento oficial do protocolo →
                    </a>
                  </div>
                </div>
              </BoxConteudo>
              <BoxConteudo boxTitulo="CIDs">
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '6px',
                    fontSize: '1.2rem',
                    marginTop: '-10px',
                  }}
                >
                  {[
                    { codigo: 'M05.0', descricao: 'Síndrome de Felty' },
                    {
                      codigo: 'M05.1',
                      descricao: 'Doença reumatoide do pulmão',
                    },
                    { codigo: 'M05.2', descricao: 'Vasculite reumatoide' },
                    {
                      codigo: 'M05.3',
                      descricao:
                        'Artrite reumatoide com comprometimento de outros órgãos e sistemas',
                    },
                    {
                      codigo: 'M05.8',
                      descricao: 'Outras artrites reumatoides soropositivas',
                    },
                    {
                      codigo: 'M06.0',
                      descricao: 'Artrite reumatoide soronegativa',
                    },
                    {
                      codigo: 'M06.8',
                      descricao: 'Outras artrites reumatoides especificadas',
                    },
                  ].map((cid) => (
                    <div key={cid.codigo}>
                      <strong>{cid.codigo}</strong> - {cid.descricao}
                    </div>
                  ))}
                </div>
              </BoxConteudo>
              <BoxConteudo boxTitulo="Critérios de Inclusão e Exclusão">
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                    fontSize: '1.2rem',
                    marginTop: '-10px',
                  }}
                >
                  {/* Inclusão */}
                  <div>
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: '1.2rem',
                        borderLeft: '4px solid #1351B4',
                        paddingLeft: '8px',
                        backgroundColor: '#F0F4FF',
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        borderRadius: '6px',
                      }}
                    >
                      Critérios de Inclusão
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4px',
                      }}
                    >
                      {[
                        'Diagnóstico confirmado conforme critérios clínicos e laboratoriais estabelecidos.',
                        'Idade igual ou superior a 18 anos.',
                        'Presença de atividade moderada a grave da doença.',
                        'Falha ou intolerância ao tratamento de primeira linha.',
                      ].map((item, index) => (
                        <div key={`inc-${index}`}>• {item}</div>
                      ))}
                    </div>
                  </div>

                  {/* Exclusão */}
                  <div>
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: '1.25rem',
                        borderLeft: '4px solid #1351B4',
                        paddingLeft: '8px',
                        backgroundColor: '#F0F4FF',
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        borderRadius: '6px',
                      }}
                    >
                      Critérios de Exclusão
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4px',
                      }}
                    >
                      {[
                        'Gestação ou lactação sem avaliação médica especializada.',
                        'Infecção ativa não tratada.',
                        'Histórico de reação adversa grave ao medicamento indicado.',
                        'Comorbidades que contraindiquem o uso da terapia proposta.',
                      ].map((item, index) => (
                        <div key={`exc-${index}`}>• {item}</div>
                      ))}
                    </div>
                  </div>
                </div>
              </BoxConteudo>
              <BoxConteudo boxTitulo="Documentos e Exames">
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                    fontSize: '1.2rem',
                    marginTop: '-10px',
                  }}
                >
                  {/* Documentos */}
                  <div>
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: '1.25rem',
                        borderLeft: '4px solid #1351B4',
                        paddingLeft: '8px',
                        backgroundColor: '#F0F4FF',
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        borderRadius: '6px',
                      }}
                    >
                      Documentos Obrigatórios
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4px',
                      }}
                    >
                      {[
                        'Laudo médico detalhado com CID correspondente.',
                        'Prescrição médica atualizada.',
                        'Relatório clínico com histórico terapêutico.',
                        'Termo de Consentimento Livre e Esclarecido (quando aplicável).',
                      ].map((item, index) => (
                        <div key={`doc-${index}`}>• {item}</div>
                      ))}
                    </div>
                  </div>

                  {/* Exames */}
                  <div>
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: '1.25rem',
                        borderLeft: '4px solid #1351B4',
                        paddingLeft: '8px',
                        backgroundColor: '#F0F4FF',
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        borderRadius: '6px',
                      }}
                    >
                      Exames Necessários
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4px',
                      }}
                    >
                      {[
                        'Hemograma completo.',
                        'Provas de função hepática (TGO, TGP).',
                        'Velocidade de hemossedimentação (VHS) ou PCR.',
                        'Exames de imagem quando indicados clinicamente.',
                      ].map((item, index) => (
                        <div key={`exam-${index}`}>• {item}</div>
                      ))}
                    </div>
                  </div>
                </div>
              </BoxConteudo>
              <BoxConteudo boxTitulo="Outros medicamentos que fazem parte deste protocolo">
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                    fontSize: '1.2rem',
                    marginTop: '-10px',
                  }}
                >
                  <div
                    style={{
                      fontWeight: 600,
                      fontSize: '1.25rem',
                      borderLeft: '4px solid #1351B4',
                      paddingLeft: '8px',
                      backgroundColor: '#F0F4FF',
                      paddingTop: '4px',
                      paddingBottom: '4px',
                      borderRadius: '6px',
                    }}
                  >
                    Medicamentos Associados
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '6px',
                    }}
                  >
                    {[
                      'Metotrexato',
                      'Prednisona',
                      'Leflunomida',
                      'Adalimumabe',
                      'Etanercepte',
                    ].map((med, index) => (
                      <div key={`med-${index}`}>• {med}</div>
                    ))}
                  </div>
                </div>
              </BoxConteudo>
            </WorkspaceFicha>
          )}
        </CustomOffcanvas>
        {/* </div> */}
      </div>
    </DetailPageWrapper>
  );
}

export default MedsusPublicDetail;
